import { eventChannel } from "redux-saga";
import { call, fork, put, take } from "redux-saga/effects";
import { setTime } from "..";

function timer() {
  return eventChannel(emitter => {
    const timerID = setInterval(() => emitter(new Date()), 1000);
    return () => {
      clearInterval(timerID);
    };
  });
}

function* updateTimer() {
  const chan = yield call(timer);
  while (true) {
    const time: Date = yield take(chan);
    yield put(setTime(+time));
  }
}

export default function*() {
  yield fork(updateTimer);
}
